import type { ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'ghost';
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export default function Button({ children, variant = 'ghost', onClick, className = '', disabled = false }: ButtonProps) {
  const baseClasses = "px-3.5 py-2 rounded-xl border text-[0.8rem] cursor-pointer inline-flex items-center gap-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variantClasses = {
    primary: "bg-gradient-to-br from-accent to-[#e86fde] border-transparent text-[#05060a] font-semibold shadow-[0_0_0_1px_rgba(0,0,0,0.4)]",
    ghost: "border-border-soft bg-[#0a0b14]/80 text-text hover:bg-white/5"
  };

  return (
    <button 
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
}
